module.exports = "/_next/static/images/UseAI-1345e4fc1018e47a80934cfc34d75e52.webp";